import Controller from "./promotionValue.controller";
import template from "./promotionValue.html";

const promotionValue = {
  template,
  controller: Controller,
  bindings: {
    selected: "=",
    eventName: "<",
    permissionName: "@",
    city: "<",
    isRequired: "<",
    isDisabled: "<",
  },
};

export default promotionValue;



// WEBPACK FOOTER //
// ./src/components/promotionValue/promotionValue.component.js